/* modal */
const app = document.querySelector<HTMLElement>('#app');
/*--------------------------------------------------------------------------------*/
const tmpBtnSave: string = /* html */ `
    <button class="solid green" type="submit">
        <i>&#xf0c7;</i>บันทึก
    </button>
`;
const tmpBtnCancel: string = /* html */ `
    <button class="solid gray" type="button" id="btn-cancel">
        <i>&#xf057;</i>ยกเลิก
    </button>
`;
const tmpBtnClose: string = /* html */ `
    <button class="solid blue" type="button" id="btn-close">
        <i>&#xf057;</i>ปิดหน้า
    </button>
`;
type ModalParams = {
    icon: string;
    title: string;
    body: string;
    width?: string;
    button?: {
        save?: boolean;
        cancel?: boolean;
        close?: boolean;
        align?: string;
    };
    target?: HTMLElement;
};
/*--------------------------------------------------------------------------------*/
export const create = (params: ModalParams): HTMLElement => {
    const icon = params.icon ? params.icon : '&#xf40e;';
    const title = params.title ? params.title : 'Modal Title';
    const body = params.body ? params.body : 'Modal Body';
    const width = params.width ? params.width : '100%';
    const align = params.button?.align ? params.button?.align : '';
    const doc = params.target ? params.target : app;
    // button
    let button = '';
    if (params.button?.cancel) button += tmpBtnCancel;
    if (params.button?.close) button += tmpBtnClose;
    if (params.button?.save) button += tmpBtnSave;
    // create
    const modal = document.createElement('div');
    modal.className = 'overlay slim-modal';
    modal.innerHTML = /*html*/ `
        <form>
            <div class="content" style="width: ${width};">
                <div class="header">
                    <i class="icon pad">${icon}</i>${title}
                    <button id="btn-exit" type="button"
                        class="icon">&#xf00d;</button>
                </div>
                <div class="body">${body}</div>
                <div class="footer ${align}">${button}</div>
                <div class="loader">
                    <div class="spinner s28"></div>
                </div>
            </div>
        </form>
    `;
    if (!doc) return modal;
    doc.appendChild(modal);
    if (width == 'auto') {
        const content = modal.querySelector<HTMLElement>('.content');
        if (content) content.style.maxWidth = `450px`;
    }
    // open modal
    window.location.hash = 'modal';
    const content = modal.querySelector<HTMLElement>('.content')!;
    content.classList.add('modal-in');
    modal.classList.add('overlay-in');
    content.addEventListener('animationend', () => {
        if (content.classList.contains('modal-in')) {
            content.classList.remove('modal-in');
            modal.classList.remove('overlay-in');
        }
    });
    // hash change
    const hashChange = () => {
        const hash = (window.location.hash).replaceAll('#', '');
        if (hash != 'modal') done();
    };
    const done = () => {
        destroy(modal);
        if (window.location.hash == '#modal') history.back();
        window.removeEventListener('hashchange', hashChange);
    };
    window.addEventListener('hashchange', hashChange);
    // button
    const btnExit = modal.querySelector<HTMLButtonElement>('#btn-exit');
    const btnCancel = modal.querySelector<HTMLButtonElement>('#btn-cancel');
    const btnClose = modal.querySelector<HTMLButtonElement>('#btn-close');
    if (btnExit) {
        btnExit.focus();
        btnExit.onclick = done;
    }
    if (btnCancel) btnCancel.onclick = done;
    if (btnClose) btnClose.onclick = done;
    return modal;
};
/*--------------------------------------------------------------------------------*/
export const close = (modal: HTMLElement) => new Promise<void>((resolve) => {
    modal.querySelector<HTMLButtonElement>('#btn-exit')!.click();
    const content = modal.querySelector<HTMLElement>('.content')!;
    content.addEventListener('animationend', () => resolve());
});
const destroy = (modal: HTMLElement) => {
    const content = modal.querySelector<HTMLElement>('.content')!;
    content.classList.add('modal-out');
    modal.classList.add('overlay-out');
    content.addEventListener('animationend', () => {
        if (content.classList.contains('modal-out')) {
            modal.style.display = 'none';
            modal.remove();
        }
    });
};
/*--------------------------------------------------------------------------------*/
export const loading = (modal: HTMLElement) => {
    const body = modal.querySelector<HTMLElement>('.body');
    const loader = modal.querySelector<HTMLElement>('.loader');
    if (body) body.style.visibility = 'hidden';
    if (loader) loader.style.display = 'flex';
};
/*--------------------------------------------------------------------------------*/
export const ready = (modal: HTMLElement) => {
    const body = modal.querySelector<HTMLElement>('.body');
    const loader = modal.querySelector<HTMLElement>('.loader');
    if (body) body.style.visibility = 'visible';
    if (loader) loader.style.display = 'none';
};
/*--------------------------------------------------------------------------------*/
export const hidden = (modal: HTMLElement) => {
    modal.style.display = 'none';
};
export const visible = (modal: HTMLElement) => {
    modal.style.display = 'block';
};
/*--------------------------------------------------------------------------------*/
